import { Container } from "react-bootstrap";
import Content from "Types/Content";
import monoTest from "Contents/Testing/imgs/mono.gif";

const Test = () => {
  return (
    <Container className='pt-3'>
      <div className='text-center'>
        <h1>
          <a>- Testing -</a>
        </h1>
        <img
          className='rounded m-4'
          width={280}
          test-
          alt='gif'
          height={190}
          src={monoTest}
        />
      </div>
      <p className='text-justify'>
        Si bien el proceso es un poco tedioso, consume tiempo y a veces se torna
        un poco frustrante, está muy bueno a medida que le vas agarrando la
        mano. <strong>Ten paciencia!</strong>
        <br />
        <br />
        La idea de esta <strong>simple guia</strong> (sujeta a
        cambios/modificaciones/correcciones) es, mediante algunos ejemplos,
        ayudarte en tus primeros pasos haciendo tests y que luego puedas sumar
        tus conocimeintos al desarrollo de esta seccion en Crombie-Docs.
        <br />
        <br />
        <h2>¡Comencemos!</h2>
        <br />
        Para hacer los test utilizaremos la libreria{" "}
        <strong>@testing-library</strong> que ya está instalada. Para consultar
        su documentacion podes hacer click{" "}
        <a
          href='https://testing-library.com/docs/react-testing-library/intro'
          target='_blank'>
          acá.
        </a>
        <br />
        Esta{" "}
        <a
          href='https://create-react-app.dev/docs/running-tests/'
          target='_blank'>
          pagina
        </a>{" "}
        tambien te puede ayudar mucho.
        <br />
        Para correr los tests, en la <strong>terminal</strong> ejecutá el
        comando "<strong>npm run test</strong>" y, debajo, irá mostrando si hay
        algún error o si el test funciona correctamente de la siguiente manera:
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`//Si esta todo bien:
Test Suites: 1 passed, 1 total
Tests:       1 passed, 1 total
Snapshots:   0 total
Time:        10.525 s

//Si algo anda mal:
Test Suites: 1 failed, 1 passed, 2 total
Tests:       1 passed, 1 total
Snapshots:   0 total
Time:        8.559 s
`}
          </code>
        </pre>
      </p>
      <p className='text-justify'>
        Antes de arrancar, prestá atención en lo siguiente, te ayudará a ir
        viendo lo que te "devuelve" cada <strong>expect</strong> dentro de un
        test y saber si vas por buen camino:
      </p>
      <pre className='my-2'>
        <code className='language-javascript rounded'>
          {`describe("...", () => {
    test("...", async () => {
        expect(...).toMatchSnapshot();
    });
});
`}
        </code>
      </pre>
      <p className='text-justify'>
        El metodo <strong>.toMatchSnapshot()</strong> creará una carpeta dentro
        de donde te encontrás trabajando. Ésta incluye un archivo que muestra lo
        que contiene el parametro que estas colocando dentro del{" "}
        <strong>expect()</strong>.{" "}
        <strong>LUEGO DE PEGARLE UNA MIRADITA, BORRÁ LA CARPETA!!!</strong>
        <br />
        <br />
        <h2>¡Ejemplos!</h2>
        <br />
        Aclaracion: Los siguientes ejemplos son tests que se encuentran dentro
        de Crombie-docs y que fueron realizados por diferetes developers en
        distintas actividades. En este apartado, a modo ilustrativo solo se
        mostrarán fracciones de código pero, si te queda alguna duda, poder
        ingresar al repo y chusmear un poco.
        <br />
        <br />
        En este primer ejemplo, el test consiste en verificar si Luis se
        encuentra incluido dentro de la lista de developers declarada en
        Developers {">"} index.tsx. Por lo tanto, primero importamos el
        componente y luego nos fijamos si se contiene el nombre dentro de él.
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`index.test.tsx
import Developers from "../index";

describe("test de index.tsx de developers", () => {
    test("verifico que Luis se encuentre incluido en Developers", async () => {
      expect(Developers).toMatchSnapshot();  
      expect(Developers).toContain(LuisFernandoRamos);
    });
});
`}
          </code>
        </pre>
        <p className='text-center'>
          - Notar que para hacer los tests se debe crear otro archivo con el
          mismo nombre seguido de .test.tsx -
        </p>
        <p className='text-justify'>
          En la carpeta <strong>_snapshots_</strong> podremos ver que nuestro
          test es valido ya que Developers contiene a Luis en su lista.{" "}
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`  Content {
    "Component": [Function],
    "route": "luis-fernando-ramos",
    "title": "Luis Fernando Ramos",
  },
`}
          </code>
        </pre>
        <p className='text-justify'>
          En el siguiente ejemplo empezamos a usar el <strong>render</strong>.
          Como lo dice la palabra, renderiza el HTML correspondiente a un
          componente para poder hacer test sobre el mismo.
          <br />
          El próximo test consiste en buscar en el documento, el texto que se
          pasa como argumento dentro de <strong>getByText()</strong>.
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`justomedina.tsx

const JustoMedina = () => {
    return (
        <div className={ProfileStyle.title}>
        <h2>Justo Alejandro Medina</h2>
        </div>
    );
};

justomedina.test.tsx

describe("test de mi perfil", () => {
    test("verifico que el perfil tenga mi nombre en el título", async () => {
      render(<JustoMedina.Component />);
      expect(screen.getByText(/Justo Alejandro Medina/i)).toBeInTheDocument();
    });
});
`}
          </code>
        </pre>
        <p className='text-justify'>
          Siguiendo con el renderizado, tenemos el siguiente ejemplo donde, en
          este caso, hay un componente al que se le pasan parametros al
          renderizar (items e indicator) y ademas, se estan usando metodos
          (container y getByTitle) que proveé la libreria y que nos son útiles
          para realizar diferentes test.
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`carrousel.tsx

const Carousel: React.FC<CarouselProps> = ({ arrows, indicators, autoMove, items }) => {
  return (
    <div title={autoMove ? "autoMove" : ""} className={CarrouselStyle.carousel}>
      {arrows ? ( <BTNArrows tab={tab} setTab={setTab} contChildrens={contChildrens} /> ) : null}
      {indicators ? ( <BTNTabsIndicators tab={tab} setTab={setTab} contChildrens={contChildrens} /> ) : null}
    </div>
  );
};

carrousel.test.tsx

describe("test de verificación de funcionalidad en La Guia de Trackeo en Jira", () => {
  test("ver que no se carguen las flechas pero si los tabs", () => {
    const { container, getByTitle } = render( <Carousel items={CarouselInfoList} indicators={true} /> );
    expect(container.querySelector("[title='container-arrows']")).toBeNull();
    expect(getByTitle("tabs-indicators")).toBeInTheDocument();
  });
});
`}
          </code>
        </pre>
        <p className='text-justify'>
          En el siguiente ejemplo se presenta un test donde se simula un click y
          se verifica que, al hacer click, se cambie de estilo. Los estilos en
          este caso serían, uno para desplegar un texto (deploy) y el otro, para
          contraer el mismo (contract).
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`accordion.tsx

const Accordion: React.FC<QuestionsProps> = ({ questions }) => {
  return (
    <div className='container p-3 text-muted'>
      <div className={AccordionStyle.accordion} data-testid='claseAccordion' >
        {questions.map(({ answer, reply }, index) => ( <AccordionItem key={index} answer={answer} reply={reply} /> ))}
      </div>
    </div>
  );
};

accordion.test.tsx

describe("test de accordion", () => {
  test("verificar que al hacer click se cambie de estilo", () => {
    const { container, getByText } = render( <Accordion questions={Questions} /> );
    //al hacer click, deberia cambiar de estilo
    act(() => { fireEvent( getByText(Questions[0].answer), new MouseEvent("click", { bubbles: true, cancelable: true }) ); });
    expect(container.getElementsByClassName("deploy")).not.toBeDisabled;
    //se vuelve a simular un click, deberia volver cambiar de estilo
    act(() => { fireEvent( getByText(Questions[0].answer), new MouseEvent("click", { bubbles: true, cancelable: true }) ); });
    expect(container.getElementsByClassName("contract")).not.toBeDisabled;
  });
});
`}
          </code>
        </pre>
        <p className='text-justify'>
          Ahora pasamos a la parte donde realizamos los test sobre componentes
          que utilicen hooks en su interior. Para ello usaremos{" "}
          <strong>jest.mock()</strong>, que nos permitirá simular hooks y
          funciones existentes fuera del alcance del componente en cuestión.
          <br />
          Por cualquier duda, te dejo a mano el{" "}
          <a
            href='https://jestjs.io/docs/mock-functions#using-a-mock-function'
            target='_blank'>
            link
          </a>{" "}
          con la documentacion.
          <br />
          <br />
          El siguiente ejemplo muestra como se simula el uso de un customHooks
          pasandole valores ficticios para luego realizar el test.
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`usePokeInfoCard.ts

const usePokeInfo = (id: number) => {
  const getPokemonImg = async (idImg: number) => {
    const res = await fetch(https:/pokeapi.co/api/v2/pokemon/{idImg});
    const resultado = await res.json();
    await getPokemonColor(resultado.id);
    setPokeImg({ img: resultado.sprites.front_default, gif: resultado.sprites.versions["generation-v"]["black-white"]
    .animated.front_default });
  };
};

pokemoncard.tsx

const PokemonCard: React.FC<PokemonCardProps> = ({ id, name, onClick }) => {
  return (
    <div className={PokeStyle.titulo} data-testid='nombre-pokemones'>
    <h4>{name.toUpperCase().split("-")[0]}</h4>
    </div>
    <div className={PokeStyle.extraimg}>
    {loading ? ( <Spinner animation='border' /> ) : ( <img src={pokeImg?.gif || pokeImg?.img} alt='pokeimg' /> )}
    </div>
  );
};

index.test.tsx

jest.mock("Examples/PokeDex/usePokeInfoCard", () => {
  return () => ["green", { img: "pokemon.png" }, false];
});

describe("test mocked componentes", () => {
  test("verifica que cargue una img del pokemon", () => {
    const { getAllByAltText } = render(<PokemonCard name='pikachu' id={3} />);
    getAllByAltText(/pokeimg/gi).forEach(img => { expect(img).toHaveAttribute("src"); });
  });
});
`}
          </code>
        </pre>
        <p className='text-justify'>
          En el ejemplo de arriba se muestran 3 archivos. En el primero tenemos
          usePokeInfoCard.ts que es un customHooks donde se obtienen los valores
          de la api, en este caso, obtengo la imagen del pokemon (entre otros
          datos).
          <br />
          Despues, está pokemoncand.tsx que es donde se carga y se muestra la
          imagen. (podes ver las cards en Ejemplos {" > "} PokeDex)
          <br />
          Por último, en pokemoncard.test.tsx, usamos jest.mock() para simular
          una llamada al customHook enviandole datos ramdoms para hacer el test
          donde verificamos si se está cargando la img dentro de la card.
          <br />
          <br />
          El siguiente ejemplo de abajo, verifica que se muestren todos los
          detalles del pokemon en el modal, para ello, primero usamos el mock
          pasandole valores de algún pokemon ramdom.
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`usePokeModal.ts
     
jest.mock("Examples/PokeDex/usePokeInfoModal", () => {
return () => [ {
pokeAability: "poison-point", pokeForm: "nidoran-m", pokeMove: "cut", pokeName: "nidoran-m",
  pokeSpecies: "nidoram-m", pokeStatNumber: "46", pokeStatName: "hp", pokeType: "poison"
},
"green", "healing", "sinnoh-route-202", { img: "nidoranImgFront.png", imgBack: "nidoranImgBack.png" },
false ];
});

pokemonmodal.tsx

const PokemonModal: React.FC<PokeModal> = ({ id, visible, onClickBack }) => {
const [ pokeDetalles, pokeColor, pokeCategory, pokeLocation, pokeImg, loading] = usePokeInfoModal(id);
return (
  <div className={PokeStyle.PokemonModalBack} onClick={onClickBack}>
    <div className={PokeStyle.gif}>
      <div className={PokeStyle.modalImg}>
          {pokeImg?.img && <img src={pokeImg?.img} alt='modalImgFront' />}
          {pokeImg?.imgBack && ( <img src={pokeImg?.imgBack} alt='modalImgBack' /> )}
      </div>
      <div className={PokeStyle.modalDetalles} data-testid='modal-detalles' >
          <h4>Name: {pokeDetalles?.pokeName}</h4>
          <h4>Ability: {pokeDetalles?.pokeAbility}</h4>
          <h4>Form: {pokeDetalles?.pokeForm}</h4>
          <h4>Move: {pokeDetalles?.pokeMove}</h4>
          <h4>Species: {pokeDetalles?.pokeSpecies}</h4>
          <h4> Stat: {pokeDetalles?.pokeStatNumber} {pokeDetalles?.pokeStatName} </h4>
          <h4>Type: {pokeDetalles?.pokeType}</h4>
          <h4>Category: {pokeCategory}</h4>
          <h4>Location: {pokeLocation}</h4>
      </div>
    </div>
  </div>
  );
}; 

index.test.tsx

describe("test mocked componentes", () => { 
  test("verifica que el modal cargue todas las caracteristicas", () => {
      const { container, getAllByAltText } = render( <PokemonModal id={1} visible={true} /> );
      const modalDetalles = container.querySelector( "[data-testid='modal-detalles']" );
    getAllByAltText(/modalImgFront/gi).forEach(img => { expect(img).toHaveAttribute("src"); });
      getAllByAltText(/modalImgBack/gi).forEach(imgBack => { expect(imgBack).toHaveAttribute("src"); });
      expect(modalDetalles).toHaveTextContent("Name:");
      expect(modalDetalles).toHaveTextContent("Form:");
      expect(modalDetalles).toHaveTextContent("Move:");
      expect(modalDetalles).toHaveTextContent("Species:");
      expect(modalDetalles).toHaveTextContent("Stat:");
      expect(modalDetalles).toHaveTextContent("Type:");
      expect(modalDetalles).toHaveTextContent("Category:");
      expect(modalDetalles).toHaveTextContent("Location:");
    });
  });
});
`}
          </code>
        </pre>
        {/* EJEMPLOS DE TESTS DE ACÁ PARA ARRIBA */}
        <p className='text-justify'>
          <br />
          <h2>¡Coverage!</h2>
          <br />
          Como último punto (y no menos importante) a tener en cuenta, es el{" "}
          <strong>code coverage</strong>. La cobertura de código es un método de
          análisis que determina qué partes de nuestro código han sido
          cubiertas, es decir, han sido ejecutadas por las pruebas unitarias, y
          qué partes no lo han sido.
          <br />
          Para obtener esta informacion, tenés que ejecutar el comando "
          <strong>npm test -- --coverage --watchAll</strong>" en la{" "}
          <strong>terminal</strong> y ahí podemos ver el siguiente informe: (el
          informe corresponde al proyecto Crombie-docs)
          <br />
          Nota: este comando tambien crea una carpeta (coverage). Antes de hacer
          un push, tenés que eliminarla!
        </p>
        <pre className='my-2'>
          <code className='language-javascript rounded'>
            {`---------------------------------------------|---------|----------|---------|---------|----------------------------------------
File                                         | % Stmts | % Branch | % Funcs | % Lines | Uncovered Line #s
---------------------------------------------|---------|----------|---------|---------|----------------------------------------
All files                                    |   32.45 |    25.37 |   29.31 |  35.19  | 
  src                                        |   50    |    25    |   75    |  50     |
  App.tsx                                    |   91.67 |    50    |   90    |  91.67  | 37 
  index.tsx                                  |   0     |    100   |   100   |  0      | 7-17 
  reportWebVitals.ts                         |   0     |     0    |    0    |  0      | 3-10
src/Componentes/Accordion                    |   100   |    100   |   100   |  100    |
  AccordionItem.tsx                          |   100   |    100   |   100   |  100    | 
  index.tsx                                  |   100   |    100   |   100   |  100    | 
src/Componentes/CardInfoFede                 |   100   |    66.67 |   100   |  100    |
  InfoCard.tsx                               |   100   |    100   |   100   |  100    | 
  ItemCard.tsx                               |   100   |    66.67 |   100   |  100    | 12-23 
src/Componentes/CarouselFede                 |   85    |    79.17 |   75    |  84.21  | 
  BTNArrows.tsx                              |   75    |    25    |   66.67 |  75     | 18
  BTNTabsIndicators.tsx                      |   85.71 |    100   |   50    |  83.33  | 22 
  Carousel.tsx                               |   85.71 |    80    |   100   |  85.71  | 25 
  CarouselItem.tsx                           |   100   |    100   |   100   |  100    | 
src/Componentes/CarouselFede/Helpers         |   16.67 |     0    |    0    |  20     |
  CarouselMoveTimeout.ts                     |   16.67 |     0    |    0    |  20     | 16-20 
src/Contents                                 |   52.38 |    100   |    0    |  52.38  | 
  CodeReview.tsx                             |   50    |    100   |    0    |  50     | 6
  Componetizacion.tsx                        |   50    |    100   |    0    |  50     | 6 
                                             |         |          |         |         |  
  ...continue...                             |   ...   |    ...   |   ...   |   ...   | ...
---------------------------------------------|---------|----------|---------|---------|----------------------------------------
Test Suites: 8 passed, 8 total 
Tests: 31 passed, 31 total
Snapshots:0 total 
Time: 18.604s 
Ran all test suites.`}
          </code>
        </pre>
        <p className='text-justify'>
          Como se puede ver, Crombie-docs tiene aproximadamente un 30% de código
          testeado. Para que un producto sea "aceptable" se busca tener, como
          minimo, un 60% <strong>(lo correcto es 80%)</strong>. Este parametro
          es de gran utilidad a la hora de vender un producto de calidad, que
          sea el que el cliente está esperando, sin defectos y confiable.
        </p>
      </p>
    </Container>
  );
};

export default new Content({
  Component: Test,
  title: "Testing",
  route: "test",
  tags: ["testing"]
});
